import { render, staticRenderFns } from "./MyPageWrapper.vue?vue&type=template&id=2d35af4e&scoped=true"
import script from "./MyPageWrapper.vue?vue&type=script&lang=ts"
export * from "./MyPageWrapper.vue?vue&type=script&lang=ts"
import style0 from "./MyPageWrapper.vue?vue&type=style&index=0&id=2d35af4e&prod&lang=scss&scoped=true"
import style1 from "./MyPageWrapper.vue?vue&type=style&index=1&id=2d35af4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d35af4e",
  null
  
)

export default component.exports